import { addOrUpdateElement } from '../../helpers'
import { SystemParam } from './types'

export const addOrUpdateSystemParam = (
  stateSystemParams: SystemParam[],
  systemParamsToAdd: SystemParam[]
) =>
  systemParamsToAdd.reduce(
    (params, param) =>
      param.isDeleted
        ? params.filter(({ id }) => id !== param.id)
        : addOrUpdateElement(params, param, (a, b) => a.id === b.id),
    stateSystemParams
  )
